/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Core.Currency_
///   This is an auto-generated enumeration of the SWFC_Learning.Core.Currency domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum Currency_ {
   /// <summary>
   ///    ()
   /// </summary>
   Default = 0,
   /// <summary>
   ///   America (United States of America), Dollars ($)
   /// </summary>
   USD = 1,
   /// <summary>
   ///   Canada, Dollars ($)
   /// </summary>
   CAD = 2,
   /// <summary>
   ///   Great Britain (United Kingdom), Pounds (£)
   /// </summary>
   GBP = 3,
   /// <summary>
   ///   European Union, Euro (€)
   /// </summary>
   EUR = 4
}

export const Currencies: Currency[] = [
   {
      code: Currency_.Default,
      literal: 'Default',
      description: '',
      shortDescription: '',
      listPriority: 0,

      typeName: "Currency"
   },
   {
      code: Currency_.USD,
      literal: 'USD',
      description: 'America (United States of America), Dollars',
      shortDescription: '$',
      listPriority: 0,

      typeName: "Currency"
   },
   {
      code: Currency_.CAD,
      literal: 'CAD',
      description: 'Canada, Dollars',
      shortDescription: '$',
      listPriority: 0,

      typeName: "Currency"
   },
   {
      code: Currency_.GBP,
      literal: 'GBP',
      description: 'Great Britain (United Kingdom), Pounds',
      shortDescription: '£',
      listPriority: 0,

      typeName: "Currency"
   },
   {
      code: Currency_.EUR,
      literal: 'EUR',
      description: 'European Union, Euro',
      shortDescription: '€',
      listPriority: 0,

      typeName: "Currency"
   }
]

export class Currency implements IDomainModel {
   code: Currency_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: Currency_): Currency {
      return Currencies.find(d => d.code === code)
   }
}
